import { ReactNode } from 'react';
import styled from 'styled-components';

interface SectionProps {
  children?: ReactNode;
  key?: any;
}

const Section = styled.div<SectionProps>`
  margin: 0 -7px;
  display: flex;
  flex-wrap: wrap;
`;

export default Section;
